import React, { FC, useEffect } from 'react';
import GallerySlider from 'components/GallerySlider/GallerySlider';
import { DEMO_STAY_LISTINGS } from 'data/listings';
import StartRating from 'components/StartRating/StartRating';
import { Link } from 'react-router-dom';
import BtnLikeIcon from 'components/BtnLikeIcon/BtnLikeIcon';
import BtnMarkerIcon from 'components/BtnMarkerIcon/BtnMarkerIcon';
import SaleOffBadge from 'components/SaleOffBadge/SaleOffBadge';
import Badge from 'shared/Badge/Badge';
import { StayDataType } from 'data/types';
import NcImage from 'shared/NcImage/NcImage';
import appConfig from 'config/appConfig';

// export interface PropertyCardHProps {
//   className?: string;
//   data?: StayDataType;
// }

// const DEMO_DATA = DEMO_STAY_LISTINGS[0];

// const PropertyCardH: FC<PropertyCardHProps> = ({
//   className = '',
//   data = DEMO_DATA,
// }) => {
//   const {
//     galleryImgs,
//     title,
//     href,
//     like,
//     saleOff,
//     isAds,
//     price,
//     reviewStart,
//     reviewCount,
//     id,
//   } = data;

//   console.log('DEMO DATA: ');
//   console.log(DEMO_DATA);

export interface PropertyCardHProps {
  className?: string;
  props?: any;
  data?: any;
  onGoToLocation?: any;
}

const PropertyCardH: FC<PropertyCardHProps> = ({
  className = '',
  data,
  onGoToLocation,
}) => {
  const {
    address,
    baths,
    beds,
    city,
    discount,
    garages,
    image,
    latitude,
    longitude,
    oldprice,
    price,
    rating,
    size,
    status,
    title,
    type,
    id,
  } = data;

  // console.log('Data: ');
  // console.log(data);

  // useEffect(() => {
  //   var numb = oldprice.match(/\d/g).join('');
  //   // numb = numb.join('');
  //   alert(numb);
  // }, []);

  let priceSalePercent: string;

  if (oldprice) {
    const priceoldNum = oldprice.match(/\d/g).join('');
    const priceNum = price.match(/\d/g).join('');
    console.log(Math.round(((priceoldNum - priceNum) / priceoldNum) * 100));

    priceSalePercent =
      '- ' +
      Math.round(((priceoldNum - priceNum) / priceoldNum) * 100) +
      '%' +
      ' price drop';
  }

  //const propertyLink = `${appConfig.URL}property/${id}`;
  const propertyLink = `/property/${id}`;
  //const propertyLink = `/property`;
  //const propertyLink = `https://vevoszerzo.whitewebdesign.hu/property`;

  const renderSliderGallery = () => {
    return (
      <div className='flex-shrink-0 p-3 w-full sm:w-64 '>
        {/* <GallerySlider
          ratioClass='aspect-w-1 aspect-h-1'
          galleryImgs={image}
          className='w-full h-full rounded-2xl overflow-hidden will-change-transform'
          uniqueID={`PropertyCardH_${id}`}
        /> */}
        <div className='aspect-w-1 aspect-h-1'>
          <NcImage
            src={image}
            className='object-cover w-full h-full rounded-2xl'
          />
        </div>

        {oldprice && priceSalePercent && (
          <SaleOffBadge
            className='absolute left-5 top-5 !bg-orange-500'
            desc={priceSalePercent}
          />
        )}
      </div>
    );
  };

  const renderTienIch = () => {
    return (
      <div className='inline-grid grid-cols-3 gap-2'>
        <div className='flex items-center space-x-2'>
          <span className='hidden sm:inline-block'>
            <i className='las la-bed text-lg'></i>
          </span>
          <span className='text-xs text-neutral-500 dark:text-neutral-400'>
            {beds + ' beds'}
          </span>
        </div>

        {/* ---- */}
        <div className='flex items-center space-x-2'>
          <span className='hidden sm:inline-block'>
            <i className='las la-bath text-lg'></i>
          </span>
          <span className='text-xs text-neutral-500 dark:text-neutral-400'>
            {baths + ' baths'}
          </span>
        </div>

        {/* ---- */}
        <div className='flex items-center space-x-2'>
          <span className='hidden sm:inline-block'>
            <i className='las la-expand-arrows-alt text-lg'></i>
          </span>
          <span className='text-xs text-neutral-500 dark:text-neutral-400'>
            {size}
          </span>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className='flex-grow p-3 sm:pr-6 flex flex-col items-start'>
        <div className='space-y-4 w-full'>
          <div className='inline-flex space-x-3'>
            <Badge
              name={
                <div className='flex items-center'>
                  <i className='text-sm las la-tag'></i>
                  <span className='ml-1'>{status}</span>
                </div>
              }
            />
            <Badge
              name={
                <div className='flex items-center'>
                  <i className=' text-sm las la-home'></i>
                  <span className='ml-1'>{type}</span>
                </div>
              }
              color='yellow'
            />
          </div>
          <div className='flex items-center space-x-2'>
            {/* {isAds && <Badge name='ADS' color='green' />} */}
            <h2 className='text-lg font-medium capitalize'>
              <span className='line-clamp-2'>{title + ' - ' + type}</span>
            </h2>
          </div>
          {renderTienIch()}
          <div className='w-14 border-b border-neutral-100 dark:border-neutral-800 '></div>
          <div className='flex w-full justify-between items-end'>
            {/* <StartRating reviewCount={reviewCount} point={reviewStart} /> */}
            <span className='flex items-center justify-center px-3 py-2 border border-secondary-500 rounded leading-none text-base font-medium text-secondary-500'>
              {/* TODO: ha for rent akkor / month-ot éár mögé írni -> type nak a id-je kéne nem 'for rent' stringel matcehlni, multialng lesz */}
              {`${price} `}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-PropertyCardH group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-3xl overflow-hidden hover:shadow-xl transition-shadow ${className}`}
      data-nc-id='PropertyCardH'
    >
      {/* <Link
        to={propertyLink}
        target={'_blank'}
        rel={'noopener noreferrer'}
        className='h-full w-full flex flex-col sm:flex-row sm:items-center'
      > */}
      <a
        href={propertyLink}
        target='_blank'
        className='h-full w-full flex flex-col sm:flex-row sm:items-center'
      >
        {renderSliderGallery()}
        {renderContent()}
      </a>
      {/* </Link> */}

      <BtnMarkerIcon
        className='absolute right-5 top-5 sm:right-3 sm:top-3'
        onPress={() => {
          console.log('click' + longitude + ' - ' + latitude);
          onGoToLocation(latitude, longitude);
        }}
      />
    </div>
  );
};

export default PropertyCardH;
